import { UserRoleEnum } from 'graphql-common';

export function getRolesOptions() {
  return [
    {
      labelKey: 'user',
      value: UserRoleEnum.User,
    },
    {
      labelKey: 'full-admin',
      value: UserRoleEnum.FullAdmin,
    },
  ];
}

export function getRoleOption(role: UserRoleEnum) {
  return getRolesOptions().find(({ value }) => value === role);
}
